/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCustomList
 */
export interface InternalApiCustomList {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomList
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomList
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomList
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomList
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomList
     */
    updatedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCustomList
     */
    lastUpdated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCustomList
     */
    canEdit?: boolean;
}

/**
 * Check if a given object implements the InternalApiCustomList interface.
 */
export function instanceOfInternalApiCustomList(value: object): value is InternalApiCustomList {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function InternalApiCustomListFromJSON(json: any): InternalApiCustomList {
    return InternalApiCustomListFromJSONTyped(json, false);
}

export function InternalApiCustomListFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'lastUpdated': json['lastUpdated'] == null ? undefined : (new Date(json['lastUpdated'])),
        'canEdit': json['canEdit'] == null ? undefined : json['canEdit'],
    };
}

export function InternalApiCustomListToJSON(json: any): InternalApiCustomList {
    return InternalApiCustomListToJSONTyped(json, false);
}

export function InternalApiCustomListToJSONTyped(value?: InternalApiCustomList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'description': value['description'],
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'lastUpdated': value['lastUpdated'] == null ? value['lastUpdated'] : value['lastUpdated'].toISOString(),
        'canEdit': value['canEdit'],
    };
}

